export const colorPalette = [
  "#4e79a7",
  "#f28e2c",
  "#e15759",
  "#76b7b2",
  "#59a14f",
  "#edc949",
  "#af7aa1",
  "#ff9da7",
  "#9c755f",
  "#bab0ab",
  "#3d6ad6", // $color-deep-blue
];

export const pastelColorPalette = [
  "#ffffff",
  "#cccccc",
  "#acd5ce",
  "#fdfdbd",
  "#c9c6db",
  "#fa9387",
  "#a0bed3",
  "#fdc17e",
  "#f9d7e9",
  "#c6a4c7",
  "#ccebc5",
];

const generateRandomNumber = (max: number) => Math.floor(Math.random() * max);

export const randomFlagColor = () => {
  const withoutWhite = pastelColorPalette.slice(1);
  return withoutWhite[generateRandomNumber(withoutWhite.length)];
};

export const randomColor = () =>
  colorPalette[generateRandomNumber(colorPalette.length)];

export const randomPastelColor = () =>
  pastelColorPalette[generateRandomNumber(pastelColorPalette.length)];

export const lightenDarkenColor = (color: string, amt: number) => {
  const col = color.replace("#", "");
  const num = parseInt(col, 16);
  const r = (num >> 16) + amt;
  const b = ((num >> 8) & 0x00ff) + amt;
  const g = (num & 0x0000ff) + amt;
  const newColor = g | (b << 8) | (r << 16);
  return `#${newColor.toString(16)}`;
};
